import React, { useEffect, useState } from 'react';
import { Box, Grid, useMediaQuery, IconButton } from '@mui/material';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow } from 'swiper';
import NextButtonIcon from '../../kit/icons/NextButtonIcon';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import styles from './styles';

function CustomCarousel({ slides }) {
  const [swiper, setSwiper] = useState(null);
  const [frame, setFrame] = useState(null);
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  useEffect(() => {
    setFrame(() =>
      isSm ? (
        <StaticImage
          src="./images/slide-frame-mobile.png"
          alt="slide-frame"
          className="frame"
        />
      ) : (
        <StaticImage
          src="./images/slide-frame-desktop.png"
          alt="slide-frame"
          className="frame"
        />
      ),
    );
  }, [isSm]);

  return (
    <Box sx={styles.sliderWrapper}>
      <Grid container sx={styles.sliderMainContainer}>
        <Grid item xs={12} md={10} sx={styles.sliderContainer}>
          <Swiper
            effect="coverflow"
            grabCursor
            centeredSlides
            loop
            slidesPerView={2.1}
            spaceBetween="-60%"
            breakpoints={{
              535: {
                slidesPerView: 2,
                spaceBetween: '-34%',
              },
            }}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 800,
              modifier: 1,
              slideShadows: false,
            }}
            modules={[EffectCoverflow]}
            onSwiper={(swiper) => {
              setSwiper(swiper);
            }}
          >
            {slides.map((item, idx) => (
              <SwiperSlide key={idx}>
                <Box sx={styles.slide}>
                  {frame}
                  <GatsbyImage
                    image={getImage(item.path)}
                    className="image"
                    alt="slide"
                  />
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Grid>
        <Grid item xs={12} sx={styles.buttonBlock}>
          <Box sx={styles.prev}>
            <IconButton onClick={() => swiper && swiper.slidePrev()}>
              <NextButtonIcon />
            </IconButton>
          </Box>
          <Box>
            <IconButton onClick={() => swiper && swiper.slideNext()}>
              <NextButtonIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CustomCarousel;
